<template>
    <div class="basicLightbox basicLightbox--visible">
        <div class="basicLightbox__placeholder" role="dialog">
            <div class="popup popup--small">
                <div class="account__container">
                    <h6 class="h6 text--grey-light mb-xs">{{ heading }}</h6>
                    <p class="text--grey-dark">{{ text }}</p>
                    <button class="btn mt-xl" @click="$emit('clicked')">{{ buttonText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        heading: {
            type: String,
            default: null
        },
        text: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
    }
}
</script>
